import { fmtStopwatch } from './clockUtils';

const show = (ms) => { const { main, cs } = fmtStopwatch(ms); return `${main}.${cs}`; };

// laps = newest-first array of total-elapsed snapshots.
export const LapList = ({ laps, current }) => {
  if (!laps.length) return <div className="h-2" />;
  const splits = laps.map((t, i) => t - (laps[i + 1] ?? 0));
  const best = laps.length > 1 ? Math.min(...splits) : null;
  const worst = laps.length > 1 ? Math.max(...splits) : null;
  return (
    <div className="w-full max-w-[340px] max-h-48 overflow-y-auto tabular-nums text-sm" data-testid="stopwatch-lap-list">
      <div className="grid grid-cols-3 px-2 pb-2 text-[11px] uppercase tracking-[0.18em] text-white/40 border-b border-white/10">
        <span>Lap</span><span className="text-center">Lap time</span><span className="text-right">Total</span>
      </div>
      <div className="grid grid-cols-3 px-2 py-2 text-white/50 border-b border-white/5">
        <span>{laps.length + 1}</span>
        <span className="text-center">{show(current - laps[0])}</span>
        <span className="text-right">{show(current)}</span>
      </div>
      {laps.map((t, i) => (
        <div
          key={t}
          className={`grid grid-cols-3 px-2 py-2 border-b border-white/5 ${
            splits[i] === best ? 'text-primary' : splits[i] === worst ? 'text-red-400' : 'text-white/85'
          }`}
          data-testid={`stopwatch-lap-row-${laps.length - i}`}
        >
          <span>{laps.length - i}</span>
          <span className="text-center">{show(splits[i])}</span>
          <span className="text-right">{show(t)}</span>
        </div>
      ))}
    </div>
  );
};

export default LapList;
